import { ArrowDownward, Block } from "@mui/icons-material";
import { Stack } from "@mui/material";
import { IOneWay, IStopSell } from "../../../../types";
import CircleAvailabilities from "../../../../../../components/circle-availability/CircleAvailability";
import TooltipAvailabilities from "./TooltipAvailbilities";

const CellAvailabilities = ({
    availableCars,
    oneWayInS,
    stopSells
}: {
    availableCars: number,
    oneWayInS: IOneWay[],
    stopSells: IStopSell | null
}) => {

    if (oneWayInS?.length > 0 || stopSells) {
        return (
            <TooltipAvailabilities
                enterDelay={500}
                enterNextDelay={500}
                disableInteractive
                oneWayInS={oneWayInS}
                stopSells={stopSells}
            >
                <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                    <Stack direction="row" alignItems="center" columnGap={1}>
                        <CircleAvailabilities availableCars={availableCars} />
                        <Stack direction="row" alignItems="center">
                            {oneWayInS && (oneWayInS?.length > 0) && <ArrowDownward fontSize="inherit" />}
                            {stopSells && <Block fontSize="small" sx={{ ml: .5 }} color="error" />}
                        </Stack>
                    </Stack>
                </Stack>
            </TooltipAvailabilities>
        )
    }

    return <CircleAvailabilities availableCars={availableCars} />;
}

export default CellAvailabilities;
